const contactInfo = [
  {
    label: "Address",
    value: "Domovinskog rata 2",
    icon: "ri-map-pin-line",
  },
  {
    label: "City",
    value: "Solin",
    icon: "ri-building-line",
  },
  {
    label: "Zip",
    value: "21210",
    icon: "ri-mail-open-line",
  },
  {
    label: "Country",
    value: "Croatia",
    icon: "ri-global-line",
  },
  {
    label: "Email",
    value: "help@grundaldoo.com",
    icon: "ri-mail-line",
  },
  {
    label: "Phone",
    value: "+1 7407626590",
    icon: "ri-phone-line",
  },
];

export default function ContactSection() {
  return (
    <section id="contact" className="bg-gray-900 py-24">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Top Row */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-16 border-b border-white/10 pb-12">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://public.readdy.ai/ai/img_res/0d2f963b-8ae8-4acd-826c-58151275469e.png"
                alt="GRUNDAL d.o.o. Logo"
                className="h-10 w-auto object-contain"
              />
              <span className="text-white font-bold text-xl tracking-wide">GRUNDAL d.o.o.</span>
            </div>
            <p className="text-white/50 text-sm max-w-sm leading-relaxed">
              Developing modern iOS applications that enhance security and user experience for mobile users worldwide.
            </p>
          </div>
          <div className="text-white/30 text-sm">
            iOS Application Development
          </div>
        </div>

        {/* Contact Info Grid */}
        <div>
          <p className="text-xs uppercase tracking-[0.25em] text-white/40 font-medium mb-8">
            Contact Information
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {contactInfo.map((item) => (
              <div key={item.label} className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-white/5 flex-shrink-0">
                  <i className={`${item.icon} text-white/50 text-base`} />
                </div>
                <div>
                  <p className="text-white/40 text-xs uppercase tracking-widest mb-1 font-medium">
                    {item.label}
                  </p>
                  <p className="text-white text-base font-medium">{item.value}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Contact Form */}
        <div className="mt-16 bg-white/5 rounded-2xl p-8 md:p-10">
          <h3 className="text-white text-xl font-semibold mb-2">Send Us a Message</h3>
          <p className="text-white/40 text-sm mb-8">
            Have a question or inquiry? Fill out the form below and we&apos;ll get back to you.
          </p>
          <form
            id="contact-form"
            data-readdy-form
            action="https://readdy.ai/api/form/d7b3ul6oim692ipjlu5g"
            method="POST"
            onSubmit={async (e) => {
              e.preventDefault();
              const form = e.currentTarget;
              const data = new URLSearchParams(new FormData(form) as unknown as Record<string, string>);
              try {
                const res = await fetch("https://readdy.ai/api/form/d7b3ul6oim692ipjlu5g", {
                  method: "POST",
                  headers: { "Content-Type": "application/x-www-form-urlencoded" },
                  body: data.toString(),
                });
                if (res.ok) {
                  const msg = form.parentElement?.querySelector("#form-success");
                  if (msg) (msg as HTMLElement).style.display = "block";
                  form.reset();
                }
              } catch {
                // silent
              }
            }}
            className="grid grid-cols-1 md:grid-cols-2 gap-5"
          >
            <div className="flex flex-col gap-1.5">
              <label className="text-white/50 text-xs uppercase tracking-widest">Full Name</label>
              <input
                type="text"
                name="full_name"
                required
                placeholder="John Doe"
                className="bg-white/5 border border-white/10 rounded-lg px-4 py-3 text-white text-sm placeholder-white/20 focus:outline-none focus:border-white/30 transition-colors"
              />
            </div>
            <div className="flex flex-col gap-1.5">
              <label className="text-white/50 text-xs uppercase tracking-widest">Email Address</label>
              <input
                type="email"
                name="email"
                required
                placeholder="you@example.com"
                className="bg-white/5 border border-white/10 rounded-lg px-4 py-3 text-white text-sm placeholder-white/20 focus:outline-none focus:border-white/30 transition-colors"
              />
            </div>
            <div className="flex flex-col gap-1.5 md:col-span-2">
              <label className="text-white/50 text-xs uppercase tracking-widest">Message</label>
              <textarea
                name="message"
                required
                rows={4}
                maxLength={500}
                placeholder="Your message here..."
                className="bg-white/5 border border-white/10 rounded-lg px-4 py-3 text-white text-sm placeholder-white/20 focus:outline-none focus:border-white/30 transition-colors resize-none"
              />
            </div>
            <div className="md:col-span-2 flex items-center gap-4">
              <button
                type="submit"
                className="bg-white text-gray-900 text-sm font-semibold px-8 py-3 rounded-lg hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap"
              >
                Send Message
              </button>
              <div id="form-success" style={{ display: "none" }} className="text-green-400 text-sm">
                Message sent successfully!
              </div>
            </div>
          </form>
        </div>

        {/* Footer Bottom */}
        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/30 text-xs">
            &copy; {new Date().getFullYear()} GRUNDAL d.o.o. All rights reserved.
          </p>
          <p className="text-white/20 text-xs">
            Domovinskog rata 2, Solin 21210, Croatia
          </p>
        </div>
      </div>
    </section>
  );
}
